import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { setIntervalImmediate } from './interval';
var STEP_MS = 35;
var MAX_VALUE = 1;
export var ProgressManager = /*#__PURE__*/function () {
  function ProgressManager(_ref) {
    var onProgressValueChange = _ref.onProgressValueChange;

    _classCallCheck(this, ProgressManager);

    this._onProgressValueChange = onProgressValueChange;
    this._autoplayDuration;
    this._onProgressValueChange;
    this._interval;
    this._paused = false;
  }

  _createClass(ProgressManager, [{
    key: "setAutoplayDuration",
    value: function setAutoplayDuration(autoplayDuration) {
      this._autoplayDuration = autoplayDuration;
    }
  }, {
    key: "start",
    value: function start(onFinish) {
      var _this = this;

      return new Promise(function (resolve) {
        _this.reset();

        var stepMs = Math.min(STEP_MS, Math.max(_this._autoplayDuration, 1));
        var progress = -stepMs;
        _this._interval = setIntervalImmediate( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var value;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!_this._paused) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  progress += stepMs;
                  value = progress / _this._autoplayDuration;

                  _this._onProgressValueChange(value);

                  if (!(value > MAX_VALUE)) {
                    _context.next = 10;
                    break;
                  }

                  _this.reset();

                  _context.next = 9;
                  return onFinish();

                case 9:
                  resolve();

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })), stepMs);
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      this._paused = true;
    }
  }, {
    key: "resume",
    value: function resume() {
      this._paused = false;
    }
  }, {
    key: "reset",
    value: function reset() {
      clearInterval(this._interval);

      this._onProgressValueChange(MAX_VALUE);
    }
  }]);

  return ProgressManager;
}();